import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function AnnouncementBanner() {
  return (
    <div className="relative bg-[#0B0B0B] border-b border-[#C8A97E]/15 pt-[120px] md:pt-[128px]">
      <Link
        to="/about/our-story"
        className="group block py-2 px-6 md:px-10 transition-colors hover:bg-[#141414]"
      >
        <p className="text-center text-[11px] md:text-[12px] tracking-[0.14em] text-[#F0E9DC] leading-snug">
          Dr. Valerie Roth Dentistry is now Beechwood Dental Studio.
          <span className="inline-block">
            <span className="mx-2 text-[#F0E9DC]/40">&middot;</span>
            <span className="inline-flex items-center gap-1.5 border-b border-transparent group-hover:border-[#F0E9DC] pb-0.5 transition-colors">
              Read our story
              <ArrowRight
                size={13}
                strokeWidth={1.6}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </span>
          </span>
        </p>
      </Link>
    </div>
  );
}
